export default __webpack_public_path__ + "resources/icons/d141-a1cd.webp";